export default __webpack_public_path__ + "static/media/picThanhNguyen.9a5e3eb9.png";